import React, { useContext } from "react"
import MicrocopyContext from "~contexts/MicrocopyContext"

import { LoggedIn } from "~components/Markdown"

import * as style from "./style.module.scss"

const LoggedInPanel = ({
  id, nameRef, onLogOut, onCreateApp, ...props
}) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <LoggedIn>
      <p>{microcopy.text("app_button.logged_in.description")}</p>

      <div>
        <label>
          {microcopy.text("app_button.logged_in.labels.application")}
        </label>
        {microcopy.text(
          `app_button.logged_in.app_types.${props.authentication_type}`,
        )}
      </div>

      <div>
        <label>{microcopy.text("app_button.logged_in.labels.name")}</label>
        <input type="text" ref={nameRef} defaultValue={props.name} />
      </div>

      <hr />

      <div>
        <label>{microcopy.text("app_button.logged_in.labels.scopes")}</label>
        {props.scopes.map(({ scope }) => (
          <div key={scope}>
            {microcopy.text(`app_button.logged_in.scopes.${scope}`, scope)}
          </div>
        ))}
      </div>
      <div data-inline>
        <label>
          {microcopy.text("app_button.logged_in.labels.can_act_as_user")}
          :
        </label>
        {props.can_act_as_user
          ? microcopy.text("app_button.logged_in.values.yes")
          : microcopy.text("app_button.logged_in.values.no")}
      </div>
      <div data-inline>
        <label>
          {microcopy.text("app_button.logged_in.labels.redirect_url")}
          :
        </label>
        {props.redirect_url
          || microcopy.text("app_button.logged_in.values.none")}
      </div>
      <div data-inline>
        <label>
          {microcopy.text("app_button.logged_in.labels.cors_origins")}
          :
        </label>
        {" "}
        {props.cors_origins
          || microcopy.text("app_button.logged_in.values.none")}
      </div>

      <hr />

      <div className={style.buttons}>
        <a data-logoutbutton onClick={onLogOut}>
          {microcopy.text("app_button.logged_in.buttons.logout")}
        </a>
        <button onClick={onCreateApp}>
          {microcopy.text("app_button.logged_in.buttons.create_app")}
        </button>
      </div>
    </LoggedIn>
  )
}

export default LoggedInPanel
